export const getPercentValues = ({
	propertyPrice,
	percentOwnResources,
	percentCreditValue,
}: {
	propertyPrice: number;
	percentOwnResources: number;
	percentCreditValue: number;
}): {
	percentOwnResources: string;
	percentCreditValue: string;
	ownResources: string;
	creditValue: string;
	formula: number;
} => {
	const ownResources = propertyPrice * percentOwnResources;
	const creditValue = propertyPrice - ownResources;
	const formula = (creditValue * 9789) / 1_000_000;

	return {
		percentOwnResources: String(percentOwnResources),
		percentCreditValue: String(percentCreditValue),
		ownResources: String(ownResources),
		creditValue: String(creditValue),
		formula,
	};
};

export function currencyFormat(value: string, localeFormat = "es-CO"): string {
	const valueNumber = Number(value.replace(/[^0-9]/g, ""));
	return valueNumber > 0 ? new Intl.NumberFormat(localeFormat).format(valueNumber) : "";
}

